import type { Vehicle } from "@/types";

// Ordem da lista "Frota" do mapa (pedido 2026-10-03): Online, depois
// Parado, depois Offline. Dentro de cada grupo, última comunicação mais
// recente primeiro — em faixas de 10 min: online/parado comunicam a cada
// poucos segundos, e comparar o horário exato embaralhava a lista inteira
// a cada poll de 15s (cartões trocando de lugar, foto/endereço recarregando
// — relatado no mesmo dia). Mesma faixa → nome, estável entre polls.
const STATUS_RANK: Record<Vehicle["status"], number> = { online: 0, idle: 1, offline: 2 };

const BUCKET_MS = 10 * 60 * 1000;

function lastSeenBucket(v: Vehicle): number {
  const t = Date.parse(v.lastConnection);
  return Number.isFinite(t) ? Math.floor(t / BUCKET_MS) : 0;
}

// Um Collator só, reaproveitado: `localeCompare(b, "pt-BR", {...})` monta
// um comparador de idioma novo a CADA chamada — com a frota de 2.800+ isso
// sozinho custava ~1 s no celular a cada F5 (medido 2026-10-05).
export const NAME_COLLATOR = new Intl.Collator("pt-BR", { numeric: true });

export function compareVehiclesByStatus(a: Vehicle, b: Vehicle): number {
  return (
    (STATUS_RANK[a.status] ?? 3) - (STATUS_RANK[b.status] ?? 3) ||
    lastSeenBucket(b) - lastSeenBucket(a) ||
    NAME_COLLATOR.compare(a.name, b.name) ||
    (a.id < b.id ? -1 : a.id > b.id ? 1 : 0)
  );
}

export function sortVehiclesByStatus<T extends Vehicle>(list: readonly T[]): T[] {
  // Chaves calculadas uma vez por veículo (não a cada comparação do sort).
  const keyed = list.map((v) => ({ v, rank: STATUS_RANK[v.status] ?? 3, bucket: lastSeenBucket(v) }));
  keyed.sort(
    (a, b) =>
      a.rank - b.rank ||
      b.bucket - a.bucket ||
      NAME_COLLATOR.compare(a.v.name, b.v.name) ||
      (a.v.id < b.v.id ? -1 : a.v.id > b.v.id ? 1 : 0),
  );
  return keyed.map((k) => k.v);
}
